import React, { ComponentProps } from "react";

import MaskedInput from "react-text-mask";

type TextMaskCustomProps = {
  inputRef: (ref: HTMLInputElement | null) => void;
} & ComponentProps<typeof MaskedInput>;

const WrappedMaskedInput: React.FC<TextMaskCustomProps> = ({
  inputRef,
  mask,
  showMask = true,
  guide = false,
  ...rest
}) => (
  <MaskedInput
    {...rest}
    ref={(ref: any) => {
      inputRef(ref ? ref.inputElement : null);
    }}
    mask={mask}
    showMask={showMask}
    guide={guide}
  />
);

export default WrappedMaskedInput;
